import {ApiResponse} from "../models/class.api.response";

/*
FUNCTIONS
*/
export const callAPI = function(endpoint, data = [], method = 'GET') {
    return new window.Promise((resolve, reject) => {
        let methods = [ 'get', 'post', 'put', 'delete' ];
        method = method.toLowerCase();

        if(methods.includes(method) === false)
        {
            reject(Lang.get('common.invalid-api-method-specified'));
        }

        axios[method](endpoint, data)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
}

export const empty = function(my_var) {
    if(typeof my_var === 'undefined' || my_var === null) {
        return true;
    }

    my_var = my_var.replaceAll(' ', '')
        .replaceAll("\n", "")
        .replaceAll("\r", "");

    return my_var === '';
}

export const formatCurrency = function(number, strip_currency_name = true) {
    let formatter = new Intl.NumberFormat('fr-CA', {
        style: 'currency',
        currency: 'CAD',
        // minimumFractionDigits: 0,
        // maximumFractionDigits: 0,
    });

    let amount = formatter.format(number);

    if(strip_currency_name === true)
    {
        amount = amount.replace(' CA', '');
    }

    return amount;
}

export const isset = function(my_var) {
    return !(typeof my_var === 'undefined' || my_var === null);
}

export const roundAmount = function(amount) {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
}

export const roundCents = function(amount) {
    let round_floor = Math.floor(amount / 0.05) * 0.05;
    let round_ceil = Math.ceil(amount / 0.05) * 0.05;
    let diff_floor = amount - round_floor;
    let diff_ceil = round_ceil - amount;

    if(diff_floor < diff_ceil)
    {
        return round_floor;
    }

    return round_ceil;
}

export const warning = function(body, title = '') {
    let $warning = $('#warningModal');

    $warning.find('.modal-body').html(body);

    if(!empty(title))
    {
        $warning.find('.modal-title').html(title);
    }

    $warning.modal('show');
}
